import { Injectable } from '@angular/core';
import {  AUTH0_CONFIGS, Auth0Config } from '../../../environments/auth0-config';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root',
})
export class Auth0ConfigService {
  getConfig(): Auth0Config {
    const profile = environment.profile;
    const config = AUTH0_CONFIGS[profile];
    const redirectLocal = environment.redirectLocal;
    const localApi = environment.localApi;
    const localUrl = 'http://localhost:5000';
    if (!config) {
      throw new Error(`Auth0 configuration for profile "${profile}" not found`);
    } 
    
    if(redirectLocal) {
      config.auth.authorizationParams.redirect_uri = 'http://localhost:4200/secure';
    }

    if(localApi) {
      config.auth.apiUri = localUrl;
      config.apiUrl = localUrl;
      config.gqlUrl = `${localUrl}/graphql`;
      config.httpInterceptor.allowedList = [`${localUrl}/*`];
    }
    return config;
  }
}